import { render, staticRenderFns } from "./ReferrerThirdPage.vue?vue&type=template&id=72c3213e&scoped=true"
import script from "./ReferrerThirdPage.vue?vue&type=script&lang=js"
export * from "./ReferrerThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ReferrerThirdPage.vue?vue&type=style&index=0&id=72c3213e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3213e",
  null
  
)

export default component.exports